import { parseISO } from "date-fns";
import { isArray } from "lodash";
import { LogOut } from "lucide-react";
import { useMemo } from "react";
import { useNavigate } from "react-router";

import LogoSymbol from "@/assets/logos/LogoSymbol.svg";
import { Button } from "@/components/ui/button";
import { useGetOrganizationInvitationssQuery } from "@/data/queries";
import useStore from "@/state";

export const NoOrganization = () => {
  const { session, logOut } = useStore();
  const navigate = useNavigate();

  const { data, isLoading } = useGetOrganizationInvitationssQuery();

  const pendingInvites = useMemo(() => {
    if (!isArray(data)) {
      return [];
    }

    return data.filter((invite) => invite.state === "pending");
  }, [data]);

  if (!session) {
    navigate("/");
    return null;
  }

  return (
    <div>
      <div className="flex items-center justify-end p-4">
        <p className="mr-4 text-muted-foreground">{session.user.email}</p>
        <Button variant="secondary" onClick={logOut}>
          <LogOut /> Log Out
        </Button>
      </div>
      <div className="space-y-6 flex justify-center align-center flex-col w-[600px] mx-auto mt-12">
        <img src={LogoSymbol} alt="Legitimate" className="h-12 w-12 block" />
        <div className="space-y-4">
          <h1 className="text-2xl font-medium tracking-tight">
            Welcome to Legitimate
          </h1>
          {!isLoading && pendingInvites && pendingInvites.length == 0 && (
            <>
              <p>
                Please reach out to Legitimate at help@legitimate.tech or
                contact an admin at the organization you're trying to join for
                an invitation.
              </p>
              <p>
                If you accepted an invite but are still seeing this message,
                your invitation may have expired.
              </p>
              <div className="bg-gray-100 p-2 rounded-md w-full">
                <code className="text-xs ">
                  Email: {session?.user.email}
                  <br />
                  Organization ID: {session?.organization_id}
                  <br />
                  User ID: {session?.user.id}
                  <br />
                  Role: {session?.role}
                  <br />
                  Session ID: {session?.session_id}
                  <br />
                </code>
              </div>
            </>
          )}

          {pendingInvites && pendingInvites.length > 0 && (
            <>
              <p>
                You have been invited to join an organization. Accept an
                invitation to continue.
              </p>
              <div className="space-y-4">
                {pendingInvites.map((invite) => (
                  <div
                    className="bg-gray-100 p-4 rounded-md w-full space-y-2"
                    key={invite.id}
                  >
                    <h2>{invite.organization_name}</h2>
                    <p className="text-sm">
                      From {invite.inviter_email} - expires{" "}
                      {parseISO(invite.expires_at || "").toLocaleDateString()}
                    </p>

                    <Button
                      className="mt-2"
                      onClick={() => {
                        window.location.href = invite.accept_invitation_url;
                      }}
                    >
                      Accept
                    </Button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
